import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  static targets = ["events"]

  connect() {
    this.wasHidden = document.visibilityState === "hidden"
    this.handleVisibilityChange = this.handleVisibilityChange.bind(this)
    this.handlePageShow = this.handlePageShow.bind(this)
    this.observer = new MutationObserver((mutations) => this.scrollToNewEvent(mutations))
    this.observer.observe(this.eventsTarget, { childList: true })
    document.addEventListener("visibilitychange", this.handleVisibilityChange)
    window.addEventListener("pageshow", this.handlePageShow)
    window.requestAnimationFrame(() => this.scrollToInitialEvent())
  }

  disconnect() {
    this.observer?.disconnect()
    document.removeEventListener("visibilitychange", this.handleVisibilityChange)
    window.removeEventListener("pageshow", this.handlePageShow)
  }

  handleVisibilityChange() {
    if (document.visibilityState === "hidden") {
      this.wasHidden = true
      return
    }

    if (!this.wasHidden) return

    this.wasHidden = false
    this.refreshSession()
  }

  handlePageShow(event) {
    if (event.persisted) this.refreshSession()
  }

  refreshSession() {
    if (this.refreshing) return

    this.refreshing = true
    const url = new URL(window.location.href)
    url.searchParams.delete("event")
    url.hash = ""
    Turbo.visit(url.toString(), { action: "replace" })
  }

  scrollToInitialEvent() {
    const fragmentId = window.location.hash.slice(1)
    const fragmentEvent = fragmentId ? document.getElementById(fragmentId) : null
    this.scrollTo(fragmentEvent || this.eventsTarget.lastElementChild, "auto")
  }

  scrollToNewEvent(mutations) {
    const event = mutations
      .flatMap((mutation) => Array.from(mutation.addedNodes))
      .find((node) => node instanceof Element && node.matches("[data-codex-session-event]"))

    this.scrollTo(event, this.prefersReducedMotion ? "auto" : "smooth")
  }

  scrollTo(event, behavior) {
    event?.scrollIntoView({ behavior, block: "nearest" })
  }

  get prefersReducedMotion() {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches
  }
}
